import React, { useMemo } from 'react';
import cn from 'classnames';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { ReactComponent as InfoIcon } from 'assets/img/alert-icons/info.svg';

export default function ShopperGroupIncentiveIcon({
  type = '',
  incentives = [],
  // groupName = '',
  iconClassName = '',
  message = 'Customer group incentive applied'
}) {
  const show = useMemo(() => {
    if (!_isArray(incentives) || _isEmpty(incentives)) return false;
    return incentives.some(incentive => incentive === type);
  }, [type, incentives]);

  if (!type) return null;

  return (
    <UiKit.Tooltip disabled={!show}>
      <UiKit.Tooltip.Trigger>
        <InfoIcon className={cn(styles.icon, iconClassName)} />
      </UiKit.Tooltip.Trigger>
      <UiKit.Tooltip.Content>{message}</UiKit.Tooltip.Content>
    </UiKit.Tooltip>
  );
}
